import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { DurationRange } from '@y42/date-time';
import { BaseCellRendererComponent } from '../base-cell-renderer.component';

@UntilDestroy()
@Component({
  selector: 'y42-duration-cell-renderer',
  template: `<y42-duration [durationRange]="state.durationRange"></y42-duration>`,
})
export class DurationCellRendererComponent extends BaseCellRendererComponent<DurationRange> {
  public readonly state = connectState(this, {
    durationRange: this.valueAsSingle$,
  });
}
